module.exports = __webpack_public_path__ + "img/item-7(1920)new.6b7d4fb7.jpg";